import { IUser } from 'src/app/core/interfaces/user.interface';
import { ICaseType } from 'src/app/modules/unit/interfaces/case-type.interface';

export enum IndicatorsTexts {
  created = 'Creados',
  process = 'En proceso',
  finished = 'Finalizados',
}

export enum IndicatorsTextsAlert {
  created = 'Creados',
  process = 'Asignados',
  refused = 'Rechazados',
}
export interface Indicators {
  created: Data;
  process: Data;
  finished: Data;
}
export interface IndicatorsAlert {
  created: Data;
  process: Data;
  refused: Data;
}
interface Data {
  value: number;
  diff: number;
}

export interface Indicator {
  icon: string;
  title: string;
  value: number;
  diff: number;
}

export interface TypeCase {
  _id: ICaseType;
  amount: number;
  percentage: number;
}
export interface AnalystData {
  _id: IUser;
  amount: number;
  color: string;
}
export interface AnalystDataType {
  _id: any;
  amount: number;
  color: string;
}
export interface CasesPerWeek {
  week: string;
  created: number;
  finished: number;
}

export interface AlertPerWeek {
  week: string;
  initial: number;
  proceed: number;
  refused: number;
  finished: number;
}

export interface AlertChannel {
  labels: string[];
  amount: number[];
}
